import { Icon } from '@iheartjane/reefer';
import type { SVGProps } from 'react';

import type { KioskIconProps } from './KioskIconProps';

const AllProducts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6152 5.74218L3.06732 18.9727L22.1632 18.9727L12.6152 5.74218ZM22.1632 21.9727C24.61 21.9727 26.0277 19.2012 24.5958 17.2171L15.0479 3.9866C13.8505 2.32737 11.38 2.32737 10.1826 3.9866L0.634633 17.2171C-0.797212 19.2012 0.620523 21.9727 3.06732 21.9727L22.1632 21.9727Z"
      fill="#CE349A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44 28H29L29 43H44V28ZM29 25C27.3431 25 26 26.3431 26 28V43C26 44.6569 27.3431 46 29 46H44C45.6569 46 47 44.6569 47 43V28C47 26.3431 45.6569 25 44 25H29Z"
      fill="#FF5500"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3209 28.5643L12.5 26.5156L10.6791 28.5643C9.81982 29.5311 8.67109 30.1943 7.40417 30.4551L4.71949 31.0077L5.58326 33.609C5.99087 34.8366 5.99088 36.163 5.58326 37.3906L4.71949 39.9919L7.40417 40.5445C8.67109 40.8053 9.81982 41.4685 10.6791 42.4353L12.5 44.484L14.3209 42.4353C15.1803 41.4685 16.329 40.8053 17.5959 40.5445L20.2806 39.9919L19.4168 37.3906C19.0092 36.163 19.0092 34.8366 19.4168 33.609L20.2806 31.0077L17.5959 30.4551C16.329 30.1943 15.1803 29.5311 14.3209 28.5643ZM14.7423 24.5226C13.549 23.18 11.4511 23.18 10.2577 24.5226L8.43681 26.5713C8.00716 27.0547 7.4328 27.3863 6.79934 27.5167L4.11466 28.0693C2.35518 28.4315 1.30626 30.2483 1.87235 31.9531L2.73611 34.5544C2.93992 35.1682 2.93992 35.8314 2.73611 36.4452L1.87235 39.0465C1.30626 40.7514 2.35518 42.5681 4.11465 42.9303L6.79934 43.4829C7.4328 43.6133 8.00716 43.9449 8.43681 44.4283L10.2577 46.477C11.4511 47.8197 13.549 47.8197 14.7423 46.477L16.5633 44.4283C16.9929 43.9449 17.5673 43.6133 18.2007 43.4829L20.8854 42.9303C22.6449 42.5681 23.6938 40.7514 23.1277 39.0465L22.264 36.4452C22.0601 35.8314 22.0601 35.1682 22.264 34.5544L23.1277 31.9531C23.6938 30.2483 22.6449 28.4315 20.8854 28.0693L18.2007 27.5167C17.5673 27.3863 16.9929 27.0547 16.5633 26.5713L14.7423 24.5226Z"
      fill="#63B8D2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29 12C29 16.4183 32.5817 20 37 20C41.4183 20 45 16.4183 45 12C45 7.58172 41.4183 4 37 4C32.5817 4 29 7.58172 29 12ZM37 1C30.9249 1 26 5.92487 26 12C26 18.0751 30.9249 23 37 23C43.0751 23 48 18.0751 48 12C48 5.92487 43.0751 1 37 1Z"
      fill="#FFC220"
    />
  </svg>
);

const AllProductsMono = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37 20C32.5817 20 29 16.4183 29 12C29 7.58172 32.5817 4 37 4C41.4183 4 45 7.58172 45 12C45 16.4183 41.4183 20 37 20ZM26 12C26 5.92487 30.9249 1 37 1C43.0751 1 48 5.92487 48 12C48 18.0751 43.0751 23 37 23C30.9249 23 26 18.0751 26 12ZM3.06733 18.9727L12.6153 5.74218L22.1632 18.9727L3.06733 18.9727ZM24.5959 17.2171C26.0277 19.2012 24.61 21.9727 22.1632 21.9727H3.06734C0.620538 21.9727 -0.797197 19.2012 0.634648 17.2171L10.1826 3.9866C11.38 2.32737 13.8505 2.32737 15.0479 3.9866L24.5959 17.2171ZM29 28H44V43H29V28ZM26 28C26 26.3431 27.3432 25 29 25H44C45.6569 25 47 26.3431 47 28V43C47 44.6569 45.6569 46 44 46H29C27.3432 46 26 44.6569 26 43V28ZM14.321 28.5643L12.5 26.5156L10.6791 28.5643C9.81983 29.5311 8.67111 30.1943 7.40419 30.4551L4.71951 31.0077L5.58327 33.609C5.99089 34.8366 5.99089 36.163 5.58327 37.3906L4.71951 39.9919L7.40419 40.5445C8.6711 40.8053 9.81983 41.4685 10.6791 42.4353L12.5 44.484L14.321 42.4353C15.1803 41.4685 16.329 40.8053 17.5959 40.5445L20.2806 39.9919L19.4168 37.3906C19.0092 36.163 19.0092 34.8366 19.4168 33.609L20.2806 31.0077L17.5959 30.4551C16.329 30.1943 15.1803 29.5311 14.321 28.5643ZM14.7424 24.5226C13.549 23.18 11.4511 23.18 10.2577 24.5226L8.43682 26.5713C8.00717 27.0547 7.43281 27.3863 6.79935 27.5167L4.11467 28.0693C2.3552 28.4315 1.30627 30.2483 1.87236 31.9531L2.73613 34.5544C2.93994 35.1682 2.93994 35.8314 2.73613 36.4452L1.87236 39.0465C1.30627 40.7514 2.3552 42.5681 4.11467 42.9303L6.79935 43.4829C7.43281 43.6133 8.00717 43.9449 8.43682 44.4283L10.2577 46.477C11.4511 47.8197 13.549 47.8197 14.7424 46.477L16.5633 44.4283C16.9929 43.9449 17.5673 43.6133 18.2007 43.4829L20.8854 42.9303C22.6449 42.5681 23.6938 40.7514 23.1277 39.0465L22.264 36.4452C22.0602 35.8314 22.0602 35.1682 22.264 34.5544L23.1277 31.9531C23.6938 30.2483 22.6449 28.4315 20.8854 28.0693L18.2007 27.5167C17.5673 27.3863 16.9929 27.0547 16.5633 26.5713L14.7424 24.5226Z"
      fill="white"
    />
  </svg>
);

export const AllProductsIcon = ({ mono, ...props }: KioskIconProps) => {
  return <Icon icon={mono ? AllProductsMono : AllProducts} {...props} />;
};
